module.exports = __webpack_public_path__ + "static/digital864e716cac831c004d1539789e57f0102.png";